/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Max_Tps_Hundred_Blocks_NameInputs */



/**
* | output |
* | --- |
* | "Max TPS (100 blocks)" |
*
* @param {Metric_Max_Tps_Hundred_Blocks_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_max_tps_hundred_blocks_name = /** @type {((inputs?: Metric_Max_Tps_Hundred_Blocks_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Max_Tps_Hundred_Blocks_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Max TPS (100 blocks)")
});